document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.xo-header');
  if (!header) return;

  function firstColorInGradient(str) {
    const match = str.match(/rgba?\([^)]+\)/);
    return match ? match[0] : null;
  }

  function isDarkRgb(rgb) {
    const m = rgb.match(/[\d.]+/g);
    if (!m) return false;
    const [r, g, b, a = 1] = m.map(Number);
    if (a < 0.3) return false;
    return (r * 299 + g * 587 + b * 114) / 1000 < 140;
  }

  function sampleImageIsDark(imgEl) {
    return new Promise((resolve) => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 10; canvas.height = 10;
        const ctx = canvas.getContext('2d');
        const hRect = header.getBoundingClientRect();
        const iRect = imgEl.getBoundingClientRect();
        const scaleX = imgEl.naturalWidth / iRect.width;
        const scaleY = imgEl.naturalHeight / iRect.height;
        const sx = Math.max(0, (hRect.left - iRect.left) * scaleX);
        const sy = Math.max(0, (hRect.top - iRect.top) * scaleY);
        const sw = Math.min(imgEl.naturalWidth, hRect.width * scaleX);
        const sh = Math.min(imgEl.naturalHeight, hRect.height * scaleY);
        ctx.drawImage(imgEl, sx, sy, sw, sh, 0, 0, 10, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        let total = 0;
        for (let i = 0; i < data.length; i += 4) {
          total += (data[i] * 299 + data[i + 1] * 587 + data[i + 2] * 114) / 1000;
        }
        resolve(total / (data.length / 4) < 140);
      } catch (e) {
        resolve(null);
      }
    });
  }

  function findBackgroundImage() {
    const rect = header.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.bottom + 5;
    header.style.pointerEvents = 'none';
    const stack = document.elementsFromPoint(x, y);
    header.style.pointerEvents = '';
    for (const el of stack) {
      if (el === header || header.contains(el)) continue;
      if (el.tagName === 'IMG' && el.complete && el.naturalWidth > 0) return el;
    }
    const top = stack.find(e => e !== header && !header.contains(e));
    if (top) {
      const img = top.querySelector('img');
      if (img && img.complete && img.naturalWidth > 0) return img;
    }
    return null;
  }

  async function detectIsDark() {
    const img = findBackgroundImage();
    if (img) {
      const result = await sampleImageIsDark(img);
      if (result !== null) return result;
    }
    const rect = header.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.bottom + 5;
    header.style.pointerEvents = 'none';
    let el = document.elementFromPoint(x, y);
    header.style.pointerEvents = '';
    while (el && el !== document.body) {
      const style = getComputedStyle(el);
      const bgImg = style.backgroundImage;
      const bgCol = style.backgroundColor;
      if (bgImg && bgImg !== 'none') {
        const c = firstColorInGradient(bgImg);
        if (c) return isDarkRgb(c);
      }
      if (bgCol && bgCol !== 'rgba(0, 0, 0, 0)' && bgCol !== 'transparent') {
        return isDarkRgb(bgCol);
      }
      el = el.parentElement;
    }
    return false;
  }

  async function updateLogo() {
    const dark = await detectIsDark();
    header.classList.toggle('is-over-dark', dark);
  }

  window.addEventListener('scroll', updateLogo, { passive: true });
  window.addEventListener('resize', updateLogo, { passive: true });
  window.addEventListener('load', updateLogo);
  setTimeout(updateLogo, 500);
  updateLogo();
});